/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_User_Admin_RevokedInputs */



/**
* | output |
* | --- |
* | "Admin Rights Revoked" |
*
* @param {Audit_Details_User_Admin_RevokedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_user_admin_revoked = /** @type {((inputs?: Audit_Details_User_Admin_RevokedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_User_Admin_RevokedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Adminrechte entzogen")
	return /** @type {LocalizedString} */ ("Admin Rights Revoked")
});